import { autoserialize } from 'cerialize';

export class ProviderFeeScheduleDetail {
  @autoserialize
  cancellationFee: number;
}
